import { resolveName } from 'components/form/final-form/useField'
import { TipoAtestadoEnum } from 'graphql/types.generated'
import React from 'react'
import { FieldArray, FieldArrayRenderProps } from 'react-final-form-arrays'
import { MetaPath } from 'util/metaPath'

import AtestadoModel, { CidadaoAtestado } from '../components/AtestadoModel'
import AtestadoPadraoForm from './AtestadoPadraoForm'

export interface AtestadoPadraoFormProps {
  name: MetaPath<AtestadoModel>
  cidadao: CidadaoAtestado
  dataAtendimento: Instant
}

export default function AtestadoPadraoView({ name, ...rest }: AtestadoPadraoFormProps) {
  const renderFieldArray = (fieldArrayRenderProps: FieldArrayRenderProps<AtestadoModel, any>) => {
    const {
      fields: { push },
    } = fieldArrayRenderProps

    const handleSubmit = (values: AtestadoModel) => {
      push({ tipo: TipoAtestadoEnum.PADRAO, ...values })
    }

    return <AtestadoPadraoForm onSubmit={handleSubmit} {...rest} />
  }

  return <FieldArray name={resolveName(name)} render={renderFieldArray} />
}
